export default {
    methods: {
        formatAsCurrency: function (number, currencyCode = null) {
            if (!currencyCode) currencyCode = this.$config.defaultCurrencyCode;
            var formatter = new Intl.NumberFormat(this.$config.currentLocale, { style: 'currency', currency: currencyCode });
            var formattedValue = formatter.format(number);
            return formattedValue;
        },
        formatAsPercentage: function (number, numberIsPercentage = false) {
            if (numberIsPercentage) {
                number = number / 100.0;
            }
            var formatter = new Intl.NumberFormat(this.$config.currentLocale, { style: 'percent' });
            var formattedValue = formatter.format(number);
            return formattedValue;
        }
    }
}